<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="page-title mb-3">
            <h3 class="text-center">Email Template Settings</h3>
          </div>

          <div class="card">
            <div class="card-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <!-- Template Image Upload -->
                  <div class="col-md-6 mb-3">
                    <label class="form-label" for="profile-picture"
                      >Template Image <span class="text-danger">*</span></label
                    >
                    <input
                      type="file"
                      id="profile-picture"
                      class="form-control"
                      @change="handleFileUpload"
                      accept="image/*"
                    />
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label"
                      >CC (comma separate)</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="cc_users"
                      placeholder="john@gmail.com, bob@gmail.com"
                    />
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label"
                      >Padding Top (px)<span class="text-danger">*</span></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      v-model="paddingTop"
                    />
                  </div>

                  <!-- Padding Left -->
                  <div class="col-md-6 mb-3">
                    <label class="form-label"
                      >Padding Left (px)<span class="text-danger"
                        >*</span
                      ></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      v-model="paddingLeft"
                    />
                  </div>

                  <!-- Submit Button -->
                  <div class="col-md-12 text-end mt-3">
                    <button type="submit" class="btn btn-primary">
                      Save Settings
                    </button>
                  </div>
                </div>
              </form>

              <!-- Live Preview with Overlay -->
              <div
                v-if="imagePreview"
                class="mt-4 position-relative"
                style="display: inline-block"
              >
                <h5>Preview:</h5>
                <img
                  :src="imagePreview"
                  class="img-fluid"
                  style="max-width: 600px"
                  @load="updatePreviewSize"
                  ref="previewImage"
                />

                <!-- Overlay text -->
                <div class="overlay-text" :style="overlayStyle">User Name</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  data() {
    return {
      templateImage: null,
      imagePreview: null,
      paddingTop: 100,
      paddingLeft: 100,
      previewWidth: 0,
      previewHeight: 0,
      cc_users:""
    };
  },
  computed: {
    overlayStyle() {
      return {
        position: "absolute",
        top: `${this.paddingTop}px`,
        left: `${this.paddingLeft}px`,
        color: "#8A6F4D",
        fontSize: "32px",
        fontWeight: "bold",
      };
    },
  },
  mounted() {
    this.loadSavedTemplate();
  },

  methods: {
    async loadSavedTemplate() {
      try {
        const response = await http.get("/email-template-settings");
        const data = response.data;

        this.imagePreview = data.image_url;
        this.paddingTop = data.padding_top;
        this.paddingLeft = data.padding_left;
        this.previewWidth = data.preview_width;
        this.previewHeight = data.preview_height;
        this.cc_users = data.cc_users ?? "";

        // Optional: prevent accidental overwrite
        this.templateImage = null;
      } catch (error) {
        console.error("No saved template or error loading template", error);
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.templateImage = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },

    updatePreviewSize() {
      const img = this.$refs.previewImage;
      this.previewWidth = img.clientWidth;
      this.previewHeight = img.clientHeight;
      console.log("Preview size:", this.previewWidth, this.previewHeight);
    },
    async submitForm() {
      this.isLoading = true;

      // Always POST for this use case
      const endpoint = "/birthday-template/save-settings";
      const method = "post";

      const formData = new FormData();
      formData.append("image", this.templateImage);
      formData.append("padding_top", this.paddingTop);
      formData.append("padding_left", this.paddingLeft);
      formData.append("preview_width", this.previewWidth);
      formData.append("preview_height", this.previewHeight);
      formData.append("cc_users", this.cc_users);

      try {
        const response = await http[method](endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.$toast.success(response.data.message);

        this.$emit("refresh");
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
        this.$toast.error(error?.response?.data?.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.btn {
  min-width: 120px;
}

.overlay-text {
  pointer-events: none;
}
</style>
